import axios from "axios";

export const fetchRecipes = async (
  ingredients,
  searchQuery,
  nextUrl = null,
) => {
  const baseUrl = "https://api.edamam.com/api/recipes/v2";
  const id = process.env.REACT_APP_API_ID;
  const key = process.env.REACT_APP_API_KEY;

  if (!id || !key)
    throw new Error(
      "Please add valid app_id and app_key, then restart the app.",
    );

  try {
    const url = nextUrl
      ? nextUrl
      : `${baseUrl}?q=${searchQuery}&type=public&app_id=${id}&app_key=${key}`;

    const cacheKey = `recipes_${searchQuery}_${ingredients}_url_${nextUrl || "first"}`;
    const cachedData = localStorage.getItem(cacheKey);
    if (cachedData) {
      return JSON.parse(cachedData);
    }

    const response = await axios.get(url);

    const allHits = response.data.hits;
    const filteredHits = filterIngredients(allHits, ingredients.split(","));

    const result = {
      hits: filteredHits,
      next: response.data._links?.next?.href || null,
    };

    localStorage.setItem(cacheKey, JSON.stringify(result));

    return result;
  } catch (error) {
    throw new Error(`Error fetching recipes: ${error.message}`);
  }
};

export function filterIngredients(recipes, ingredients) {
  return recipes.filter((recipe) => {
    const recipeIngredients = recipe.recipe.ingredientLines
      .join(" ")
      .toLowerCase();
    return ingredients.every((ingredient) =>
      recipeIngredients.includes(ingredient.toLowerCase()),
    );
  });
}

export const resetIngredientsErrors = (
  dispatch,
  setIngredientError,
  runAll,
) => {
  dispatch(setIngredientError("existingIngredient", false));
  dispatch(setIngredientError("invalidIngredient", false));
  if (runAll) dispatch(setIngredientError("emptyIngredients", false));
};
